<template>
  <div
    @click="clickRight"
    class="right-btn"
    :class="{ disabled: disabled || loading }"
  >
    <Loading v-if="loading" color="white" type="spinner" size="18px" />
    <img v-else src="./img/right.png" alt="" />
  </div>
</template>

<script>
import { Loading } from "vant";
export default {
  name: "RightBtn",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clickRight() {
      if (this.disabled || this.loading) {
        return;
      }
      this.$emit("clickRight");
    }
  },
  components: { Loading }
};
</script>

<style lang="scss" scoped>
@import "../css/var.scss";
.right-btn {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background-color: $--color-primary;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 12px;
  }
  &.disabled {
    background-color: #e2e3e5;
  }
}
</style>
